import { useCallback, useEffect, useState } from 'react';
import getAuth0Options from './getAuth0Options';
import { Auth0Lock } from 'auth0-lock';
import jwt_decode from 'jwt-decode';

const localHostnames = ['localhost', 'endtoend.docker-dev.pct.local', 'endtoend.docker-dev2.pct.local']

const getRedirectURL = (subdomain, token, redirectUrlFromState, param) => {
  const domain = process.env.REACT_APP_DOMAIN;
  const enableLocalhost = process.env.REACT_APP_ENABLE_LOCALHOST;

  try {
    const url = new URL(atob(redirectUrlFromState));
    if (localHostnames.includes(url.hostname) && enableLocalhost === 'true') {
      url.searchParams.append('access_token', token);
      url.searchParams.append('param', param);
      return url.toString();
    }
    if (domain === url.hostname.split('.')[1]) {
      url.searchParams.append('access_token', token);
      url.searchParams.append('param', param);
      return url.toString();
    }
  } catch (e) {
    if (subdomain && token) {
      return `https://${subdomain}.${domain}.hu/?access_token=${token}`;
    }
  }
};

const useAuth0 = language => {
  const [subscriptions, setSubscriptions] = useState(null);
  const [token, setToken] = useState(null);

  const tryRedirect = useCallback(
    (subdomain, tokenParam, appState) => {
      let redirect, param;
      if (appState) {
        const queryParams = new URLSearchParams(appState);
        redirect = queryParams?.get('redirect');
        param = queryParams?.get('param');
      }

      const url = getRedirectURL(subdomain, tokenParam ?? token, redirect, param);

      if (url) {
        console.info('Redirect to:', url);
        window.location.href = url;
        return true;
      }
      return false;
    },
    [token]
  );

  useEffect(() => {
    if (!language) return;

    const lock = new Auth0Lock(
      process.env.REACT_APP_AUTH0_CLIENT_ID,
      process.env.REACT_APP_AUTH0_DOMAIN,
      getAuth0Options(window.location.search, language)
    );

    const authentication = /access_token/.test(window.location.href);

    if (authentication) {
      lock.resumeAuth(window.location.hash, (error, authResult) => {
        if (authResult) {
          const subscriptions = jwt_decode(authResult.accessToken)['http://api.hr.hu/subscriptions'];

          let redirected = false;

          if (subscriptions.length === 1 || authResult.appState) {
            redirected = tryRedirect(subscriptions[0].subdomain, authResult.accessToken, authResult.appState);
          }

          if (!redirected) {
            setSubscriptions(subscriptions);
            setToken(authResult.accessToken);
          }
        }
      });
    } else if (!subscriptions) {
      //const options = { languageDictionary: authLanguages[language] };
      lock.show()
    }
    // useState kitakarítása
    return () => lock.hide();
  }, [language, subscriptions, tryRedirect]);

  return { subscriptions, tryRedirect };
};

export default useAuth0;
